module.exports = __webpack_public_path__ + "static/media/icons_grey_flip-right.70561a60.svg";